import { hideableLayoutContextMenuItems, hideableLayoutFunc } from './hideable-layout.js';

const totalConfig = {
	tagName: 'HideableLayout',
	key: 'totalHideableLayout',
	contextMenuItems: hideableLayoutContextMenuItems,
	func: hideableLayoutFunc,
	title: { desc: 'Sankey22', name: 'Total' },
	withSwitch: true,
	children: [
		{
			tagName: 'VerticalLayout',
			children: [
				{
					tagName: 'Checkbox',
					checked: false,
					key: 'showTotalOnLabel',
					text: { desc: 'Sankey23', name: 'Show total on label' }
				},
				{
					tagName: 'Radio',
					horizontal: true,
					key: 'totalAlignment',
					className: 'toggle-button-radio _2item',
					options: [
						{ name: { desc: 'Sankey24', name: 'Adjacent' }, value: 'adjacent' },
						{ name: { desc: 'Sankey25', name: 'Below' }, value: 'below' }
					],
					useButtons: true,
					useIcons: false
				}
			]
		},
		{ tagName: 'Divider' }
	]
};

export default totalConfig;
